import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { UsedCarSelectionFormFields as UsedCarSelectionFormModel } from '../../../components/UsedCarSelectionForm/UsedCarSelectionFormModels';
import { getFormUpdater } from '../../../services/common/miscUtils';
import { saveAndContinueRehydrateSlice } from '../../../services/redux/storeUtils';
import { ReduxStateWithForms, ReduxTrackedForm, createReduxTrackedFormDefaults } from '../../../types/reduxTrackedForm';

const mockedUsedCarSearchResult: UsedCarSelectionFormModel = {
  brand: 'Audi',
  chassisNumber: 'WVWZZZAUZLW009960',
  registrationNumber: '231-D-123456',
  firstRegistration: '01/04/2023',
  model: '3 Series',
  modelYear: '231',
  recordedMileage: '11056',
  trim: 'Sport',
  deliveryCost: 0,
  variant: 'BMW 320d M Sport Saloon',
  vatApplicable: 'yes',
  vehicleClass: 'Car',
  accessories: 0,
};

export interface UsedCarFormSelectorPageState extends ReduxStateWithForms<{
  usedCarSelection: ReduxTrackedForm<UsedCarSelectionFormModel>;
}> {
  usedCarSearchResult: UsedCarSelectionFormModel | null;
}

const usedCarSelectionFormInitialValues: UsedCarSelectionFormModel = {
  vehicleClass: 'car',
  vatApplicable: 'no',
  brand: '',
  model: '',
  modelYear: '',
  trim: '',
  variant: '',
  deliveryCost: 0,
  registrationNumber: '',
  chassisNumber: '',
  firstRegistration: '',
  recordedMileage: '',
  accessories: 0,
};

const initialState: UsedCarFormSelectorPageState = {
  forms: {
    usedCarSelection: {
      ...createReduxTrackedFormDefaults<UsedCarSelectionFormModel>({
        initialValues: usedCarSelectionFormInitialValues,
      }),
      values: {
        ...usedCarSelectionFormInitialValues,
      },
    },
  },
  usedCarSearchResult: mockedUsedCarSearchResult,
};

const name = 'usedCarFormSelectorPage';

export const slice = createSlice({
  name,
  initialState,
  selectors: {
    usedCarSelectionForm: (state) => state.forms.usedCarSelection,
    usedCarSearchResult: (state) => state.usedCarSearchResult,
  },
  reducers: {
    updateForm: getFormUpdater<UsedCarFormSelectorPageState>(),
    updateSearchResults: (
      state,
      action: PayloadAction<{
        data: UsedCarSelectionFormModel | null;
      }>
    ) => {
      state.usedCarSearchResult = action.payload.data;
    },
  },
  extraReducers: (builder) => {
    saveAndContinueRehydrateSlice(builder, name);
  },
});

export const usedCarFormSelectorPageSlice = slice;
export const usedCarFormSelectorPageSliceSelectors = slice.selectors;
export const usedCarFormSelectorPageSliceActions = slice.actions;
